import React from 'react';

/**
 * Small info hint shown next to a field label.
 *
 * Renders a "?" marker that carries the tooltip text in the native title
 * attribute, so the text appears on hover. The marker is marked aria-hidden so
 * it stays out of the field's accessible name (a label-text lookup still
 * resolves to the plain label). One consistent mechanism is reused by Input,
 * Checkbox, and Select.
 */

interface Props {
  text: string;
}

export const FieldTooltip: React.FC<Props> = ({ text }) => (
  <span
    aria-hidden="true"
    title={text}
    className="ml-1 inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full border border-[#E2E5EA] text-[10px] font-semibold leading-none text-heritage-grey align-middle"
  >
    ?
  </span>
);
